import axiosInstance from "./axiosInstance";

export const postRequest = async <TRequest, TResponse>(
  endpoint: string,
  data?: TRequest
): Promise<TResponse> => {
  const response = await axiosInstance.post<TResponse>(endpoint, data);
  return response.data;
};
